export default __webpack_public_path__ + "static/media/schedule-mobile.95b26e06.svg";